import React from "react";

const ProjectTitleDesc = ({ heading, desc }) => {
  return (
    <section className="flex flex-col gap-y-2">
      <span className="text-md text-gray-900 font-medium">{heading}</span>
      <p className="text-sm text-[#6B7280] p-4 bg-white border rounded-xl">
        {desc}
      </p>
    </section>
  );
};

export default ProjectTitleDesc;
